__webpack_require__.p = "/Pringles_Frontend/";